module.exports = __webpack_public_path__ + "img/tpaga.280933b.svg";